import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-einstein-conecta',
  templateUrl: './einstein-conecta.component.html',
  styleUrls: ['./einstein-conecta.component.scss']
})
export class EinsteinConectaComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
